
export const getFileExtensions = (filenames: string[]) => {
  return filenames
    .map((file) => file.split(".").pop().toLowerCase());
};
